const TabsList = {

    init() {

        // const tabs_title = document.querySelectorAll(' .payment-section .payment-header .list-payment-type .payment-type');
        // const tabs = document.querySelectorAll(' .payment-section .payment-content .step-list-container');

        const tabs_title = document.querySelectorAll('.tabs-list .tabs-list-item');
        const tabs = document.querySelectorAll('.tabs-content');


        // console.log(tabs_title);
        // console.log(tabs);

        if(tabs_title.length > 0) {
            tabs_title[0].classList.add('active');
        }

        if(tabs.length > 0) {
            for( var i = 1; i < tabs.length; i++) {
                tabs[i].classList.add('hide');
            }
        }

        if((tabs_title.length > 0) && (tabs.length > 0)) {
            tabs_title.forEach(function(tab){

                tab.addEventListener("click", function(e){
                    e.preventDefault();
                    for (i = 0; i < tabs_title.length ;i++){
                        tabs_title[i].classList.remove('active');
                    }
                    this.classList.add('active');

                    var slug = this.children[0].dataset['slug'];

                    TabsList.changeTabs(tabs_title,tabs,slug);
                })
            })
        }
    },

    changeTabs(tabs_title,tabs,slug) {
        var content_target = document.getElementById(slug);
        // console.log(content_target);
        for (var i = 0; i < tabs.length ;i++){
            tabs[i].classList.add('hide');
            // console.log(tabs[i]);
        }
        content_target.classList.remove('hide');
        // console.log(content_target)
    }
}

export default TabsList;